module.exports = __webpack_public_path__ + "static/3-489ec0613bcd5f314e86649599d3176c.png";